export interface IAppAuthorInfo {
    name: string;
    support: string;
    homepage: string;
}
